import React, { useRef, useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { openGifModalAction } from 'actions/gifModal';
import { useMediaUploadStateComment } from 'components/hooks/useMediaUploadState';
import { useDispatch } from 'react-redux';
import MediaPreview from 'screens/home/addPost/MediaPreview';
import UploadTypesView from 'screens/home/addPost/UploadTypesView';
import { commentEditorStyles, commentPlaceholderStyles } from 'styles/common';

import { SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';
import { generateKey } from 'constants/helper';

import { PostField } from 'uiToolkitV1/PostField/PostField';

import { setComment, setUploadedGif, setUploadedImage, useCompetencyDrawerState } from '../competencyDrawerSlice';

export const Comment = () => {
  const postFieldContainerRef = useRef(null);
  const dispatch = useDispatch();

  const { comment, uploadedImage, uploadedGif } = useCompetencyDrawerState();

  const [emojiPlugin, setEmojiPlugin] = useState(null);

  const setImage = (image) => {
    if (image?.url) {
      dispatch(
        setUploadedImage({
          type: 'IMAGE',
          url: image.url,
          uuid: generateKey(4),
        })
      );
    }
  };

  const setGif = (gif) => {
    if (gif) {
      dispatch(
        setUploadedGif({
          type: 'GIF',
          url: gif,
          uuid: generateKey(4),
        })
      );
    } else {
      dispatch(setUploadedGif(null));
    }
  };

  const deleteFile = () => {
    dispatch(setUploadedImage(null));
    dispatch(setUploadedGif(null));
  };

  const { uploadFile, uploading } = useMediaUploadStateComment({
    setImage,
    uploadedImage,
    setGif,
    uploadedGif,
  });

  const openGifModal = () => {
    dispatch(openGifModalAction({ onSelect: setGif }));
  };

  return (
    <Box
      ref={postFieldContainerRef}
      w="100%"
      display="flex"
      flexDir="column"
      pos="relative"
      border="1px solid #CFD7DF"
      borderRadius="4px"
      bgColor="#FFFFFF"
    >
      <PostField
        placeholder="Enter a comment..."
        updateEditorState={(editorState) => dispatch(setComment(editorState))}
        editorState={comment}
        widgetType={SEARCH_WIDGET_TYPES.comment}
        createNewTagFunctionality={false}
        useEmojiFunctionality
        allowNewLine
        // @ts-expect-error Type 'Dispatch<any>' is not assignable to type '() => void'
        setEmojiPlugin={setEmojiPlugin}
        portalParentRef={postFieldContainerRef}
        editorStyles={commentEditorStyles}
        placeholderStyles={commentPlaceholderStyles}
      />
      <MediaPreview
        fileUrl={uploadedImage?.url ?? ''}
        deleteFile={deleteFile}
        uploading={uploading}
        uploadFile={uploadFile}
        setGif={setGif}
        gifUrl={uploadedGif?.url}
        className=""
      />
      <Flex alignItems="center" pos="relative">
        <UploadTypesView
          uploadFile={uploadFile}
          uploadedImage={uploadedImage?.url}
          toggleGifModal={openGifModal}
          gifUrl={uploadedGif?.url}
          EmojiSelect={emojiPlugin?.EmojiSelect}
          className=""
        />
      </Flex>
    </Box>
  );
};
